import Show from "./show";

export default Show;
